$shm_hitalama_color_dot $mol_view
	attr *
		^
		shm_hitalama_color_transparent <= transparent false
	style *
		backgroundColor <= color \
